import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '../box';
import { omitThemingProps, useStyleConfig, vui } from '../core';
import { cs } from '../utils';
import { useBreadcrumbsContext } from './context';
/** A Breadcrumb item. */
export const BreadcrumbsItem = vui((props, ref) => {
    const { className, children, ...rest } = omitThemingProps(props);
    const styles = useStyleConfig('Breadcrumbs', useBreadcrumbsContext());
    return (_jsx(Box, { alignItems: "center", className: cs('vui-breadcrumbs-item', className), p: 0, ref: ref, ...styles.item, ...rest, children: children }));
});
BreadcrumbsItem.displayName = 'BreadcrumbsItem';
export default BreadcrumbsItem;
